// GERADO por tools/catalogo.py — não edite à mão.
// O mesmo catálogo é gravado no banco pela migration 0003 (um teste compara os dois).

export const PERMISSIONS = [
  {
    code: "admin.empresa.ver",
    module: "admin",
    description: "Ver dados da empresa",
    sensitive: false,
  },
  {
    code: "admin.empresa.editar",
    module: "admin",
    description: "Editar dados cadastrais e fiscais básicos da empresa",
    sensitive: true,
  },
  {
    code: "admin.usuarios.ver",
    module: "admin",
    description: "Ver usuários e seus papéis",
    sensitive: false,
  },
  {
    code: "admin.usuarios.convidar",
    module: "admin",
    description: "Convidar usuários",
    sensitive: true,
  },
  {
    code: "admin.usuarios.gerenciar",
    module: "admin",
    description: "Alterar papéis, suspender e reativar usuários",
    sensitive: true,
  },
  {
    code: "admin.papeis.gerenciar",
    module: "admin",
    description: "Criar e alterar papéis e suas permissões",
    sensitive: true,
  },
  {
    code: "admin.proprietarios.gerenciar",
    module: "admin",
    description: "Conceder ou retirar o papel Proprietário",
    sensitive: true,
  },
  {
    code: "admin.auditoria.ver",
    module: "admin",
    description: "Consultar a auditoria",
    sensitive: false,
  },
  { code: "cadastros.ver", module: "cadastros", description: "Ver cadastros", sensitive: false },
  {
    code: "cadastros.clientes.gerenciar",
    module: "cadastros",
    description: "Cadastrar e alterar clientes",
    sensitive: false,
  },
  {
    code: "cadastros.fornecedores.gerenciar",
    module: "cadastros",
    description: "Cadastrar e alterar fornecedores",
    sensitive: false,
  },
  {
    code: "cadastros.produtos.gerenciar",
    module: "cadastros",
    description: "Cadastrar e alterar produtos, unidades e embalagens",
    sensitive: false,
  },
  {
    code: "cadastros.vendedores.gerenciar",
    module: "cadastros",
    description: "Cadastrar e alterar vendedores",
    sensitive: false,
  },
  {
    code: "cadastros.precos.gerenciar",
    module: "cadastros",
    description: "Gerenciar tabelas de preço e formas de pagamento",
    sensitive: false,
  },
  {
    code: "producao.ver",
    module: "producao",
    description: "Ver produção e lotes",
    sensitive: false,
  },
  {
    code: "producao.ordem.lancar",
    module: "producao",
    description: "Lançar ordens de produção",
    sensitive: false,
  },
  {
    code: "producao.ordem.confirmar",
    module: "producao",
    description: "Confirmar produção (movimenta estoque)",
    sensitive: false,
  },
  {
    code: "producao.ordem.estornar",
    module: "producao",
    description: "Estornar produção confirmada",
    sensitive: true,
  },
  {
    code: "producao.ficha_tecnica.gerenciar",
    module: "producao",
    description: "Gerenciar fichas técnicas",
    sensitive: false,
  },
  {
    code: "estoque.ver",
    module: "estoque",
    description: "Ver saldos e movimentações",
    sensitive: false,
  },
  {
    code: "estoque.ajuste.lancar",
    module: "estoque",
    description: "Lançar ajustes de estoque",
    sensitive: true,
  },
  {
    code: "estoque.inventario.confirmar",
    module: "estoque",
    description: "Confirmar inventário",
    sensitive: true,
  },
  {
    code: "compras.ver",
    module: "compras",
    description: "Ver compras e entradas",
    sensitive: false,
  },
  {
    code: "compras.entrada.lancar",
    module: "compras",
    description: "Lançar entradas",
    sensitive: false,
  },
  {
    code: "compras.entrada.confirmar",
    module: "compras",
    description: "Confirmar entradas (movimenta estoque e financeiro)",
    sensitive: false,
  },
  {
    code: "compras.entrada.estornar",
    module: "compras",
    description: "Estornar entradas confirmadas",
    sensitive: true,
  },
  {
    code: "compras.xml.importar",
    module: "compras",
    description: "Importar XML de notas de entrada",
    sensitive: false,
  },
  { code: "vendas.ver", module: "vendas", description: "Ver vendas", sensitive: false },
  {
    code: "vendas.pedido.criar",
    module: "vendas",
    description: "Criar pedidos de venda",
    sensitive: false,
  },
  {
    code: "vendas.pedido.confirmar",
    module: "vendas",
    description: "Confirmar vendas (movimenta estoque e financeiro)",
    sensitive: false,
  },
  {
    code: "vendas.pedido.cancelar",
    module: "vendas",
    description: "Cancelar vendas confirmadas",
    sensitive: true,
  },
  {
    code: "vendas.desconto.acima_limite",
    module: "vendas",
    description: "Conceder desconto acima do limite",
    sensitive: true,
  },
  { code: "cargas.ver", module: "cargas", description: "Ver cargas e acertos", sensitive: false },
  {
    code: "cargas.carga.criar",
    module: "cargas",
    description: "Criar cargas de vendedor",
    sensitive: false,
  },
  {
    code: "cargas.carga.confirmar",
    module: "cargas",
    description: "Confirmar carga (transfere estoque ao vendedor)",
    sensitive: false,
  },
  {
    code: "cargas.acerto.registrar",
    module: "cargas",
    description: "Registrar acerto de vendedor",
    sensitive: false,
  },
  {
    code: "cargas.acerto.aprovar_divergencia",
    module: "cargas",
    description: "Aprovar divergência de acerto",
    sensitive: true,
  },
  {
    code: "financeiro.ver",
    module: "financeiro",
    description: "Ver contas a pagar e a receber",
    sensitive: false,
  },
  {
    code: "financeiro.titulo.lancar",
    module: "financeiro",
    description: "Lançar títulos financeiros",
    sensitive: false,
  },
  {
    code: "financeiro.baixa.registrar",
    module: "financeiro",
    description: "Registrar baixas (pagamentos e recebimentos)",
    sensitive: false,
  },
  {
    code: "financeiro.baixa.estornar",
    module: "financeiro",
    description: "Estornar baixas",
    sensitive: true,
  },
  {
    code: "financeiro.cobranca.gerar",
    module: "financeiro",
    description: "Gerar cobranças (boleto/PIX)",
    sensitive: false,
  },
  { code: "fiscal.ver", module: "fiscal", description: "Ver documentos fiscais", sensitive: false },
  {
    code: "fiscal.documento.emitir",
    module: "fiscal",
    description: "Emitir documentos fiscais",
    sensitive: true,
  },
  {
    code: "fiscal.documento.cancelar",
    module: "fiscal",
    description: "Cancelar documentos fiscais",
    sensitive: true,
  },
  {
    code: "fiscal.configuracao.editar",
    module: "fiscal",
    description: "Editar configuração fiscal",
    sensitive: true,
  },
  { code: "relatorios.ver", module: "relatorios", description: "Ver relatórios", sensitive: false },
  {
    code: "dashboard.ver",
    module: "relatorios",
    description: "Ver painel gerencial",
    sensitive: false,
  },
  {
    code: "contabilidade.exportar",
    module: "contabilidade",
    description: "Exportar pacote contábil",
    sensitive: false,
  },
  {
    code: "vendas.credito.liberar",
    module: "vendas",
    description: "Liberar venda acima do limite de crédito do cliente",
    sensitive: true,
  },
  {
    code: "estoque.transferencia.lancar",
    module: "estoque",
    description: "Lançar transferências entre depósitos (exceto de vendedor)",
    sensitive: true,
  },
  {
    code: "cargas.acerto.fechar",
    module: "cargas",
    description:
      "Finalizar acerto de carga (não o próprio); com divergência, exige também aprovar divergência",
    sensitive: true,
  },
  {
    code: "fiscal.matriz.preparar",
    module: "fiscal",
    description: "Preparar e testar regras tributárias (rascunho)",
    sensitive: true,
  },
  {
    code: "fiscal.matriz.aprovar",
    module: "fiscal",
    description: "Aprovar, publicar e encerrar regras tributárias preparadas por outra pessoa",
    sensitive: true,
  },
  {
    code: "fiscal.cancelamento.solicitar",
    module: "fiscal",
    description: "Solicitar cancelamento de documento fiscal",
    sensitive: false,
  },
  {
    code: "fiscal.documento.cancelar_proprio",
    module: "fiscal",
    description: "Cancelar somente documentos fiscais emitidos por si, no prazo",
    sensitive: true,
  },
  {
    code: "vendas.rota.confirmar",
    module: "vendas",
    description: "Confirmar as próprias vendas da rota (carga aberta)",
    sensitive: false,
  },
  {
    code: "vendas.devolucao.registrar",
    module: "vendas",
    description: "Registrar, confirmar e estornar devolução de venda",
    sensitive: true,
  },
  {
    code: "fiscal.matriz.aprovar_propria",
    module: "fiscal",
    description: "Aprovar a própria regra tributária (preparada por si), depois de testada",
    sensitive: true,
  },
  {
    code: "vendas.venda_sem_estoque",
    module: "vendas",
    description: "Vender sem estoque (a falta fica como pendência a regularizar)",
    sensitive: true,
  },
  {
    code: "cadastros.clientes.cadastrar_rota",
    module: "cadastros",
    description:
      "Cadastrar cliente simplificado durante a venda na rota (sem limite de crédito, tabela ou outros dados administrativos)",
    sensitive: false,
  },
  {
    code: "app_vendedor.acessar",
    module: "app_vendedor",
    description: "Usar o aplicativo CaféGestor Vendedor nesta empresa (abrir sessão de aplicativo)",
    sensitive: false,
  },
  {
    code: "cargas.acerto.estornar",
    module: "cargas",
    description: "Estornar acerto de carga já finalizado (não o próprio)",
    sensitive: true,
  },
  {
    code: "cargas.acerto.revisar_prestacao",
    module: "cargas",
    description:
      "Revisar prestação de contas desatualizada pelo escritório (com justificativa; quem revisa não confere nem finaliza o mesmo acerto)",
    sensitive: true,
  },
] as const;

export type PermissionCode = (typeof PERMISSIONS)[number]["code"];

export const SYSTEM_ROLES = [
  {
    key: "proprietario",
    name: "Proprietário",
    description:
      "Responsável pela empresa. Tem todas as permissões, inclusive gerenciar proprietários.",
    permissions: [
      "admin.empresa.ver",
      "admin.empresa.editar",
      "admin.usuarios.ver",
      "admin.usuarios.convidar",
      "admin.usuarios.gerenciar",
      "admin.papeis.gerenciar",
      "admin.proprietarios.gerenciar",
      "admin.auditoria.ver",
      "cadastros.ver",
      "cadastros.clientes.gerenciar",
      "cadastros.fornecedores.gerenciar",
      "cadastros.produtos.gerenciar",
      "cadastros.vendedores.gerenciar",
      "cadastros.precos.gerenciar",
      "producao.ver",
      "producao.ordem.lancar",
      "producao.ordem.confirmar",
      "producao.ordem.estornar",
      "producao.ficha_tecnica.gerenciar",
      "estoque.ver",
      "estoque.ajuste.lancar",
      "estoque.inventario.confirmar",
      "compras.ver",
      "compras.entrada.lancar",
      "compras.entrada.confirmar",
      "compras.entrada.estornar",
      "compras.xml.importar",
      "vendas.ver",
      "vendas.pedido.criar",
      "vendas.pedido.confirmar",
      "vendas.pedido.cancelar",
      "vendas.desconto.acima_limite",
      "cargas.ver",
      "cargas.carga.criar",
      "cargas.carga.confirmar",
      "cargas.acerto.registrar",
      "cargas.acerto.aprovar_divergencia",
      "financeiro.ver",
      "financeiro.titulo.lancar",
      "financeiro.baixa.registrar",
      "financeiro.baixa.estornar",
      "financeiro.cobranca.gerar",
      "fiscal.ver",
      "fiscal.documento.emitir",
      "fiscal.documento.cancelar",
      "fiscal.configuracao.editar",
      "relatorios.ver",
      "dashboard.ver",
      "contabilidade.exportar",
      "vendas.credito.liberar",
      "estoque.transferencia.lancar",
      "cargas.acerto.fechar",
      "fiscal.matriz.preparar",
      "fiscal.matriz.aprovar",
      "fiscal.cancelamento.solicitar",
      "fiscal.documento.cancelar_proprio",
      "vendas.rota.confirmar",
      "vendas.devolucao.registrar",
      "fiscal.matriz.aprovar_propria",
      "vendas.venda_sem_estoque",
      "cadastros.clientes.cadastrar_rota",
      "app_vendedor.acessar",
      "cargas.acerto.estornar",
      "cargas.acerto.revisar_prestacao",
    ] as PermissionCode[],
  },
  {
    key: "administrador",
    name: "Administrador",
    description: "Tudo, exceto conceder ou retirar o papel Proprietário.",
    permissions: [
      "admin.empresa.ver",
      "admin.empresa.editar",
      "admin.usuarios.ver",
      "admin.usuarios.convidar",
      "admin.usuarios.gerenciar",
      "admin.papeis.gerenciar",
      "admin.auditoria.ver",
      "cadastros.ver",
      "cadastros.clientes.gerenciar",
      "cadastros.fornecedores.gerenciar",
      "cadastros.produtos.gerenciar",
      "cadastros.vendedores.gerenciar",
      "cadastros.precos.gerenciar",
      "producao.ver",
      "producao.ordem.lancar",
      "producao.ordem.confirmar",
      "producao.ordem.estornar",
      "producao.ficha_tecnica.gerenciar",
      "estoque.ver",
      "estoque.ajuste.lancar",
      "estoque.inventario.confirmar",
      "compras.ver",
      "compras.entrada.lancar",
      "compras.entrada.confirmar",
      "compras.entrada.estornar",
      "compras.xml.importar",
      "vendas.ver",
      "vendas.pedido.criar",
      "vendas.pedido.confirmar",
      "vendas.pedido.cancelar",
      "vendas.desconto.acima_limite",
      "cargas.ver",
      "cargas.carga.criar",
      "cargas.carga.confirmar",
      "cargas.acerto.registrar",
      "cargas.acerto.aprovar_divergencia",
      "financeiro.ver",
      "financeiro.titulo.lancar",
      "financeiro.baixa.registrar",
      "financeiro.baixa.estornar",
      "financeiro.cobranca.gerar",
      "fiscal.ver",
      "fiscal.documento.emitir",
      "fiscal.documento.cancelar",
      "fiscal.configuracao.editar",
      "relatorios.ver",
      "dashboard.ver",
      "contabilidade.exportar",
      "vendas.credito.liberar",
      "estoque.transferencia.lancar",
      "cargas.acerto.fechar",
      "fiscal.matriz.preparar",
      "fiscal.matriz.aprovar",
      "fiscal.cancelamento.solicitar",
      "fiscal.documento.cancelar_proprio",
      "vendas.rota.confirmar",
      "vendas.devolucao.registrar",
      "fiscal.matriz.aprovar_propria",
      "vendas.venda_sem_estoque",
      "cadastros.clientes.cadastrar_rota",
      "app_vendedor.acessar",
      "cargas.acerto.estornar",
      "cargas.acerto.revisar_prestacao",
    ] as PermissionCode[],
  },
  {
    key: "gerente",
    name: "Gerente",
    description: "Operação completa e aprovação de divergências, sem administração de usuários.",
    permissions: [
      "cadastros.ver",
      "cadastros.clientes.gerenciar",
      "cadastros.fornecedores.gerenciar",
      "cadastros.produtos.gerenciar",
      "cadastros.vendedores.gerenciar",
      "cadastros.precos.gerenciar",
      "cadastros.clientes.cadastrar_rota",
      "producao.ver",
      "producao.ordem.lancar",
      "producao.ordem.confirmar",
      "producao.ordem.estornar",
      "producao.ficha_tecnica.gerenciar",
      "estoque.ver",
      "estoque.ajuste.lancar",
      "estoque.inventario.confirmar",
      "estoque.transferencia.lancar",
      "compras.ver",
      "compras.entrada.lancar",
      "compras.entrada.confirmar",
      "compras.entrada.estornar",
      "compras.xml.importar",
      "vendas.ver",
      "vendas.pedido.criar",
      "vendas.pedido.confirmar",
      "vendas.pedido.cancelar",
      "vendas.desconto.acima_limite",
      "vendas.credito.liberar",
      "vendas.rota.confirmar",
      "vendas.devolucao.registrar",
      "cargas.ver",
      "cargas.carga.criar",
      "cargas.carga.confirmar",
      "cargas.acerto.registrar",
      "cargas.acerto.aprovar_divergencia",
      "cargas.acerto.fechar",
      "cargas.acerto.estornar",
      "cargas.acerto.revisar_prestacao",
      "financeiro.ver",
      "financeiro.titulo.lancar",
      "financeiro.baixa.registrar",
      "financeiro.baixa.estornar",
      "financeiro.cobranca.gerar",
      "relatorios.ver",
      "dashboard.ver",
      "fiscal.ver",
      "contabilidade.exportar",
      "admin.empresa.ver",
      "admin.usuarios.ver",
      "app_vendedor.acessar",
    ] as PermissionCode[],
  },
  {
    key: "producao",
    name: "Produção",
    description: "Lança e confirma produção; ajustes e inventário de estoque.",
    permissions: [
      "cadastros.ver",
      "producao.ver",
      "producao.ordem.lancar",
      "producao.ordem.confirmar",
      "producao.ficha_tecnica.gerenciar",
      "estoque.ver",
      "estoque.ajuste.lancar",
      "estoque.inventario.confirmar",
      "estoque.transferencia.lancar",
      "dashboard.ver",
    ] as PermissionCode[],
  },
  {
    key: "vendedor",
    name: "Vendedor",
    description: "Cria vendas e registra o acerto das próprias cargas.",
    permissions: [
      "cadastros.ver",
      "estoque.ver",
      "vendas.ver",
      "vendas.pedido.criar",
      "cargas.ver",
      "cargas.acerto.registrar",
      "dashboard.ver",
      "fiscal.ver",
      "fiscal.documento.emitir",
      "fiscal.cancelamento.solicitar",
      "vendas.rota.confirmar",
      "cadastros.clientes.cadastrar_rota",
      "app_vendedor.acessar",
    ] as PermissionCode[],
  },
  {
    key: "financeiro",
    name: "Financeiro",
    description: "Contas a pagar e a receber, baixas, cobranças e relatórios.",
    permissions: [
      "financeiro.ver",
      "financeiro.titulo.lancar",
      "financeiro.baixa.registrar",
      "financeiro.baixa.estornar",
      "financeiro.cobranca.gerar",
      "cadastros.ver",
      "vendas.ver",
      "compras.ver",
      "relatorios.ver",
      "dashboard.ver",
      "contabilidade.exportar",
      "cargas.ver",
      "cargas.acerto.registrar",
      "cargas.acerto.fechar",
      "cargas.acerto.estornar",
    ] as PermissionCode[],
  },
  {
    key: "fiscal",
    name: "Fiscal / Contador",
    description: "Documentos fiscais, XML e exportação contábil.",
    permissions: [
      "fiscal.ver",
      "fiscal.documento.emitir",
      "fiscal.documento.cancelar",
      "fiscal.configuracao.editar",
      "fiscal.matriz.preparar",
      "fiscal.matriz.aprovar",
      "fiscal.cancelamento.solicitar",
      "fiscal.documento.cancelar_proprio",
      "cadastros.ver",
      "compras.ver",
      "compras.xml.importar",
      "vendas.ver",
      "financeiro.ver",
      "relatorios.ver",
      "contabilidade.exportar",
    ] as PermissionCode[],
  },
  {
    key: "consulta",
    name: "Consulta",
    description: "Somente leitura: telas, relatórios e painel.",
    permissions: [
      "cadastros.ver",
      "producao.ver",
      "estoque.ver",
      "compras.ver",
      "vendas.ver",
      "cargas.ver",
      "financeiro.ver",
      "fiscal.ver",
      "relatorios.ver",
      "dashboard.ver",
    ] as PermissionCode[],
  },
] as const;

export type SystemRoleKey = (typeof SYSTEM_ROLES)[number]["key"];
